import React from "react";
import { LocalizeText } from "components/localizer";
import { IMembership } from "reducers/memberships";
import { ListItemText, TextField } from "@mui/material";
import ListInlineEditWrapper from "../listComponents/listInlineEditWrapper";
import { usePermission } from "utils/hooks/usePermission";
import validator from "utils/validator";

interface IProps {
    membership: IMembership;
    onSubmitUpdate: (props: Record<string, unknown>) => void;
}

const VatNumberField: React.FC<IProps> = ({ membership, onSubmitUpdate }) => {
    const [vatNumber, setVatNumber] = React.useState(membership.vat_number || "");

    const { hasPermission } = usePermission();
    const vatNumberIsValid = validator.vatNumber(vatNumber) || !vatNumber;

    return (
        <ListInlineEditWrapper
            onChange={(e) => setVatNumber(e.target.value)}
            onSubmit={() => onSubmitUpdate({ vat_number: vatNumber })}
            label={<LocalizeText tag="vatNumber" />}
            renderInput={(props) =>
                <TextField
                    {...props}
                    value={vatNumber}
                    error={!vatNumberIsValid}
                    helperText={!vatNumberIsValid && <LocalizeText tag="errorVatNumber" />}
                />}
            renderView={(props) => <ListItemText {...props} secondary={membership.vat_number || "-"} />}
            inputIsValid={vatNumberIsValid}
            editDisabled={!hasPermission("change_membership") || !!membership.end_date || membership.is_archived}
        />
    );
};

export default VatNumberField;
